import { CanDeactivateFn } from '@angular/router';
import { TestPlanFormComponent } from './test-plan-form.component';

export const canDeactivateTestPlanForm: CanDeactivateFn<TestPlanFormComponent> = (component) => {
  return component.confirmDeactivate();
};
